<template>
    <div class="container">
        <ContentOrLoading>
            <div v-if="!loading" class="d-md-flex justify-content-center">
                <div class="d-md-inline-block">
                    <VuePaycard v-if="infoEncontrada" class="my-5" :value-fields="info_tarjeta" :labels="labels" />
                    <div v-else class="alert alert-warning" role="alert">
                        {{ $t('perfil.info_pago_erronea') }}
                    </div>
                    <div class="d-flex justify-content-center">
                        <button class="btn btn-primary mr-3 w-100" @click="showModal('editarInfo')">
                            <i class="fas fa-edit"></i> {{ $t('perfil.editar') }}
                        </button>
                    </div>
                </div>
            </div>
        </ContentOrLoading>
        <ActualizarInfoPagoModal :tid="tid" :user_id="user_id" :nueva_alta="nueva_alta" @close="closeModal('editarInfo')" />
    </div>
</template>

<script>
    import { VuePaycard } from "vue-paycard";
    import ActualizarInfoPagoModal from "./ActualizarInfoPagoModal"

    export default {
        props: {
            tid: {
                type: String,
                required: true
            },
            admin: {
                type: Boolean,
                required: false,
                default: false
            },
            user_id: {
                type: Number,
                required: false
            },
            nueva_alta: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                info_tarjeta: {
                    cardName: "",
                    cardNumber: "",
                    cardMonth: "",
                    cardYear: "",
                    cardCvv: "",
                },
                labels: {
                    cardName: "",
                    cardHolder: "Titular",
                    cardMonth: "MM",
                    cardYear: "YY",
                    cardExpires: "Caducidad",
                    cardCvv: "CVV"
                },
                loading: false,
                infoEncontrada: false
            }
        },
        created() {
            this.getInfoUsuario();
        },
        methods: {
            getInfoUsuario() {
                this.loading = true;

                if (this.admin) {
                    const params = {
                        filters: {
                            tid: this.tid,
                        },
                        user_id: this.$route.params.user_id
                    }

                    this.$store.dispatch(this.config.getVuexAlias('back.usuarios.info_pago'), params).then(res => {
                        if (!res.data.error) {
                            this.info_tarjeta.cardName = res.data.titular;
                            this.info_tarjeta.cardNumber = res.data.panVuePayCard;
                            this.info_tarjeta.cardMonth = res.data.mesCaducidad;
                            this.info_tarjeta.cardYear = res.data.anoCaducidad;
                            this.infoEncontrada = true;
                        }
                    }).catch(() => {
                        console.warn('Error al recuperar la información de pago');
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    const data = {
                        tid: this.tid,
                        filters: {}
                    }

                    this.$store.dispatch(this.config.getVuexAlias('front.perfil.info_pago'), data).then(res => {
                        if (!res.data.error) {
                            this.info_tarjeta.cardName = res.data.titular;
                            this.info_tarjeta.cardNumber = res.data.panVuePayCard;
                            this.info_tarjeta.cardMonth = res.data.mesCaducidad;
                            this.info_tarjeta.cardYear = res.data.anoCaducidad;
                            this.infoEncontrada = true;
                        }
                    }).catch(() => {
                        console.warn('Error al recuperar info de pago');
                    }).finally(() => {
                        this.loading = false
                    });
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.getInfoUsuario();
                this.$emit('update');
                this.$modal.hide(modal);
            }
        },
        components: { VuePaycard, ActualizarInfoPagoModal }
    }
</script>